var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.246281 7.989H1.92005V14.7581C1.92005 14.8917 2.03029 15 2.16633 15H5.00428C5.14032 15 5.25056 14.8917 5.25056 14.7581V8.02089H7.1747C7.29981 8.02089 7.40507 7.92866 7.41935 7.80658L7.71159 5.31455C7.71962 5.24598 7.6975 5.17732 7.65081 5.12589C7.60407 5.0744 7.53718 5.04494 7.46699 5.04494H5.25066V3.48281C5.25066 3.0119 5.50876 2.77311 6.01787 2.77311C6.09042 2.77311 7.46699 2.77311 7.46699 2.77311C7.60303 2.77311 7.71327 2.66477 7.71327 2.53118V0.243726C7.71327 0.110081 7.60303 0.00179032 7.46699 0.00179032H5.4699C5.45581 0.0011129 5.42453 0 5.37843 0C5.03191 0 3.82745 0.0668225 2.87602 0.926661C1.82184 1.8795 1.96837 3.02037 2.0034 3.21818V5.04489H0.246281C0.110235 5.04489 0 5.15318 0 5.28682V7.74702C0 7.88066 0.110235 7.989 0.246281 7.989Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7ad958d6328127d05a7fb6eafa95c4ae.svg";
export { ForwardRef as ReactComponent };